<template>
  <div v-if="api_data.Farmer">
    <div class="card rounded-0 card-custom gutter-b">
      <family-count
          v-bind:api_data="api_data"
      ></family-count>
      <div class="card-body pt-2">
        <count-label
            v-bind:label="'Male'"
            v-bind:count="api_data.Farmer.family_male"
        ></count-label>
        <count-label
            v-bind:label="'Female'"
            v-bind:count="api_data.Farmer.family_female"
        ></count-label>
      </div>
    </div>
    <div class="card rounded-0 card-custom gutter-b">
      <div class="card-body">
        <table class="table">
          <thead class="thead-light">
          <tr>
            <th scope="col">{{ $t("Particular") }}</th>
            <th scope="col">{{ $t("Count") }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th scope="row">{{ $t("Female") }} {{ $t("SHG Member") }}</th>
            <td>
              <span class="label label-inline label-light-primary font-weight-bold">{{
                  api_data.Farmer.family_female_shg_member || '0'
                }}</span>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Boy") }})</th>
            <td>
              <span class="label label-inline label-light-primary font-weight-bold">{{
                  api_data.Farmer.family_boy || '0'
                }}</span>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Boy") }} {{ $t("Play Group") }})</th>
            <td>
              <span class="label label-inline label-light-primary font-weight-bold">{{
                  api_data.Farmer.family_boy_playgroup || '0'
                }}</span>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Boy") }} {{ $t("School") }})</th>
            <td>
              <span class="label label-inline label-light-primary font-weight-bold">{{
                  api_data.Farmer.family_boy_school || '0'
                }}</span>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Girl") }})</th>
            <td>
              <span class="label label-inline label-light-primary font-weight-bold">{{
                  api_data.Farmer.family_girl || '0'
                }}</span>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Girl") }} {{ $t("Play Group") }})</th>
            <td>
              <span class="label label-inline label-light-primary font-weight-bold">{{
                  api_data.Farmer.family_girl_playgroup || '0'
                }}</span>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Girl") }} {{ $t("School") }})</th>
            <td>
              <span class="label label-inline label-light-primary font-weight-bold">{{
                  api_data.Farmer.family_girl_school || '0'
                }}</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import CountLabel from "../countLabel";
import familyCount from "../familyCount";

export default {
  name: 'show-family-information',
  components: {CountLabel, familyCount},
  props: {
    api_data: Object,
  }
}
</script>
